import { creatorbase, creatorbaseQueries } from '@round/api';
import { useQueryClient } from '@tanstack/react-query';
import { showNotification } from 'helpers';
import { copyPostUrlsToClipboardTable } from 'Modules/Plans/CopyToClipboard/PostUrlTable';
import { useState } from 'react';

export function useCopyReportCampaignPostUrls(
    platform: creatorbase.Platform,
    campaigns: creatorbase.Campaign[] | creatorbase.PublicCampaign[],
    publicReportId?: string
) {
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(false);

    async function copyReportCampaignPostUrls() {
        if (!campaigns.length) {
            showNotification('No campaigns available', 'error');
            return;
        }

        try {
            setIsLoading(true);
            const campaignIds = campaigns.map((c) => c.id).join(',');

            const posts = await queryClient.ensureQueryData(
                creatorbaseQueries.posts.options.listAll({
                    campaign_id: campaignIds,
                    platform,
                    status: 'live',
                    publicReportId,
                })
            );

            if (!posts.length) {
                showNotification('No live posts available', 'error');
                return;
            }

            const success = copyPostUrlsToClipboardTable(campaigns, posts);
            if (success) {
                showNotification('Copied!', 'info');
            } else {
                showNotification('Could not copy', 'error');
            }
        } catch {
            showNotification('Could not copy', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    return {
        isLoading,
        copyReportCampaignPostUrls,
    };
}
